// extracted by mini-css-extract-plugin
module.exports = {"v-icon":"NsAddressNz_v-icon_l5xOj","nsAddressForm":"NsAddressNz_nsAddressForm_2t3I2","dualColumn":"NsAddressNz_dualColumn_2Tnv3","firstCol":"NsAddressNz_firstCol_1QsmN"};